// API client for backend communication
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

async function request(path, { method = 'GET', body, token } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  
  try {
    const res = await fetch(`${BASE_URL}${path}`, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    });
    
    const contentType = res.headers.get('content-type') || '';
    const data = contentType.includes('application/json') ? await res.json() : await res.text();
    
    if (!res.ok) {
      throw new Error(data.message || data || res.statusText);
    }
    
    return data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
}

export const api = {
  // Auth
  login: (email, password) => request('/auth/login', { method: 'POST', body: { email, password } }),
  register: (name, email, password) => request('/auth/register', { method: 'POST', body: { name, email, password } }),
  getProfile: (token) => request('/auth/profile', { token }),
  updateProfile: (data, token) => request('/auth/profile', { method: 'PUT', body: data, token }),
  updatePreferences: (data, token) => request('/auth/preferences', { method: 'PUT', body: data, token }),
  updateCategories: (data, token) => request('/auth/categories', { method: 'PUT', body: data, token }),
  
  // Transactions
  getTransactions: (token) => request('/transactions', { token }),
  createTransaction: (data, token) => request('/transactions', { method: 'POST', body: data, token }),
  updateTransaction: (id, data, token) => request(`/transactions/${id}`, { method: 'PUT', body: data, token }),
  deleteTransaction: (id, token) => request(`/transactions/${id}`, { method: 'DELETE', token }),
  
  // Goals
  getGoals: (token) => request('/goals', { token }),
  createGoal: (data, token) => request('/goals', { method: 'POST', body: data, token }),
  updateGoal: (id, data, token) => request(`/goals/${id}`, { method: 'PUT', body: data, token }),
  deleteGoal: (id, token) => request(`/goals/${id}`, { method: 'DELETE', token }),
  
  // AI Assistant
  aiChat: (message, userStats, transactions, token) => 
    request('/ai/chat', { 
      method: 'POST', 
      body: { message, userStats, transactions }, 
      token 
    }),
  aiInsights: (userStats, transactions, token) => 
    request('/ai/insights', { 
      method: 'POST', 
      body: { userStats, transactions }, 
      token 
    }),

  // Generic methods
  get: (path, opts) => request(path, { ...opts, method: 'GET' }),
  post: (path, body, opts) => request(path, { ...opts, method: 'POST', body }),
  put: (path, body, opts) => request(path, { ...opts, method: 'PUT', body }),
  del: (path, opts) => request(path, { ...opts, method: 'DELETE' }),
};

export default api;
